export const SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS' 
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT' 
export const DELETE_PRODUCT = 'DELETE_PRODUCT' 
export const SET_NEW_PRODUCT = 'SET_NEW_PRODUCT' 